const App = () => {
  return (
    <>
      <span>template</span>
    </>
  );
};

export default App;
